/**
 * TypeScript requires us to declare any properties we add to the global 'window' object.
 * This tells the compiler that 'window.OCA' is a valid and expected property,
 * preventing a compile-time error.
 */
declare global {
    interface Window {
        OCA: any;
    }
}

// -------------------------------------------------------------------
// STEP 1: Keep any "side-effect" imports as they are.
// This line simply runs the code inside the 'app.ts' file to initialize
// your components. It does not export anything and should remain unchanged.
// -------------------------------------------------------------------

import "./facilityleadform/components/app";


// -------------------------------------------------------------------
// STEP 2: Change your export to a local import.
// This brings the addContactButtonClick function into this file's scope.
// -------------------------------------------------------------------

import { addContactButtonClick } from "./facilityleadform/api/trigger";


// -------------------------------------------------------------------
// STEP 3: Manually expose your imported function to the global scope.
// This explicitly creates the global OCA.facilityleadform_js object.
// -------------------------------------------------------------------

// Ensure the global OCA object exists, creating it if it doesn't.
window.OCA = window.OCA || {};

// Assign your imported function to the 'facilityleadform_js' property on the OCA object.
window.OCA.facilityleadform_js = {
    addContactButtonClick: addContactButtonClick
};